// extracted by mini-css-extract-plugin
var _1 = "divider__J5WCa";
var _2 = "years-select__mFi9O";
export { _1 as "divider", _2 as "yearsSelect" }
